let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <updateTime>更新时间, string (19), YYYY-MM-DD HH:MM:SS,为空时WMS自动生成</updateTime>
    <createTime>创建时间, string (19), YYYY-MM-DD HH:MM:SS,为空时WMS自动生成</createTime>
    <ownerCode>货主编码, string (50)</ownerCode>
    <palletSns>
        <palletSn>
            <palletSerialno>托序列号,string (50)</palletSerialno>
            <palletPackageType>托包装类型,string (50)</palletPackageType>
            <itemCode>商品编码, string (50)</itemCode>
            <itemName>商品名称, string (200)</itemName>
            <qty>商品数量, float</qty>
            <palletProductWeight>托盘商品重量, float</palletProductWeight>
            <virtualWarehouse>虚拟仓库, string (50)</virtualWarehouse>
            <qualityType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</qualityType>
            <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
            <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
            <batchCode>批次号, string (50)</batchCode>
            <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
            <userDefined1>自定义批次1, string (50)</userDefined1>
            <userDefined2>自定义批次2, string (50)</userDefined2>
            <userDefined3>自定义批次3, string (50)</userDefined3>
            <userDefined4>自定义批次4, string (50)</userDefined4>
            <customField1>自定义字段1, string (50)</customField1>
            <customField2>自定义字段2, string (50)</customField2>
            <customField3>自定义字段3, string (50)</customField3>
            <customField4>自定义字段4, string (50)</customField4>
            <customField5>自定义字段5, string (50)</customField5>
            <customField6>自定义字段6, string (50)</customField6>
            <customField7>自定义字段7, string (50)</customField7>
            <customField8>自定义字段8, string (50)</customField8>
            <caseSns>
                <caseSn>
                    <caseSerialno>箱序列号,string (50)</caseSerialno>
                    <casePackageType>箱包装类型,string (50)</casePackageType>
                    <itemCode>商品编码, string (50),</itemCode>
                    <itemName>商品名称, string (200)</itemName>
                    <qty>商品数量, float</qty>
                    <caseProductWeight >箱商品重量, float,</caseProductWeight >
                    <virtualWarehouse>虚拟仓库, string (50)</virtualWarehouse>
                    <qualityType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</qualityType>
                    <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
                    <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
                    <batchCode>批次号, string (50)</batchCode>
                    <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
                    <userDefined1>自定义批次1, string (50)</userDefined1>
                    <userDefined2>自定义批次2, string (50)</userDefined2>
                    <userDefined3>自定义批次3, string (50)</userDefined3>
                    <userDefined4>自定义批次4, string (50)</userDefined4>
                    <customField1>自定义字段1, string (50)</customField1>
                    <customField2>自定义字段2, string (50)</customField2>
                    <customField3>自定义字段3, string (50)</customField3>
                    <customField4>自定义字段4, string (50)</customField4>
                    <customField5>自定义字段5, string (50)</customField5>
                    <customField6>自定义字段6, string (50)</customField6>
                    <customField7>自定义字段7, string (50)</customField7>
                    <customField8>自定义字段8, string (50)</customField8>
                    <innerpackSns>
                        <innerpackSn>
                            <innerpackSerialno>内包装序列号,string (50)</innerpackSerialno>
                            <innerPackageType>内包装类型,string (50)</innerPackageType>
                            <itemCode>商品编码, string (50)</itemCode>
                            <itemName>商品名称, string (200)</itemName>
                            <qty>商品数量, float</qty>
                            <innerProductWeight>内包装商品重量, float</innerProductWeight>
                            <virtualWarehouse>虚拟仓库, string (50)</virtualWarehouse>
                            <qualityType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</qualityType>
                            <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
                            <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
                            <batchCode>批次号, string (50)</batchCode>
                            <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
                            <userDefined1>自定义批次1, string (50)</userDefined1>
                            <userDefined2>自定义批次2, string (50)</userDefined2>
                            <userDefined3>自定义批次3, string (50)</userDefined3>
                            <userDefined4>自定义批次4, string (50)</userDefined4>
                            <customField1>自定义字段1, string (50)</customField1>
                            <customField2>自定义字段2, string (50)</customField2>
                            <customField3>自定义字段3, string (50)</customField3>
                            <customField4>自定义字段4, string (50)</customField4>
                            <customField5>自定义字段5, string (50)</customField5>
                            <customField6>自定义字段6, string (50)</customField6>
                            <customField7>自定义字段7, string (50)</customField7>
                            <customField8>自定义字段8, string (50)</customField8>
                            <eachSns>
                                <eachSn>
                                    <eachSerialno>sku序列号,string (50), 必填</eachSerialno>
                                    <itemCode>商品编码, string (50), 必填</itemCode>
                                    <itemName>商品名称, string (200)</itemName>
                                    <productWeight>商品重量, float</productWeight>
                                    <virtualWarehouse>虚拟仓库, string (50)</virtualWarehouse>
                                    <qualityType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</qualityType>
                                    <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
                                    <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
                                    <batchCode>批次号, string (50)</batchCode>
                                    <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
                                    <userDefined1>自定义批次1, string (50)</userDefined1>
                                    <userDefined2>自定义批次2, string (50)</userDefined2>
                                    <userDefined3>自定义批次3, string (50)</userDefined3>
                                    <userDefined4>自定义批次4, string (50)</userDefined4>
                                    <customField1>自定义字段1, string (50)</customField1>
                                    <customField2>自定义字段2, string (50)</customField2>
                                    <customField3>自定义字段3, string (50)</customField3>
                                    <customField4>自定义字段4, string (50)</customField4>
                                    <customField5>自定义字段5, string (50)</customField5>
                                    <customField6>自定义字段6, string (50)</customField6>
                                    <customField7>自定义字段7, string (50)</customField7>
                                    <customField8>自定义字段8, string (50)</customField8>
                                </eachSn>
                            </eachSns>
                        </innerpackSn>
                    </innerpackSns>
                </caseSn>
            </caseSns>
        </palletSn>
    </palletSns>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

let NotificaitonURL = 'NotificaitonURL'

export default { xmlRequest, xmlResponse, NotificaitonURL }


// WEBPACK FOOTER //
// ./src/data/openapi/openapi.serialno.synchronize.js